import Vue from "vue";
import Router from "vue-router";
import Layout from "../components/template/Layout";
import LayoutOperator from "../components/template/LayoutOperator";
import Dashboard from "../components/Dashboard";
import FileSystem from "../components/FileSystem";
import Manage_user from "../components/Manage_user/Manage_user";
import Profile from "../components/Manage_user/Profile";
import Manage_admin from "../components/Manage_admin/Manage_admin";
import Report_sell_internet from "../components/Report_sell_internet";
import Manage_operator from "../components/Manage_operator/Manage_operator";
import Add_operator from "../components/Manage_operator/Add_operator";
import Edit_operator from "../components/Manage_operator/Edit_operator";
import Access_log from "../components/Report/Access_log";
import Report_sell_mobile from "../components/Report_sell_mobile";
import Add_admin from "../components/Manage_admin/Add_admin";
import Add_file_promotion from "../components/Manage_mobile/Add_file_promotion";
import Register from "../components/Register";
import Login from "../components/Login";
import Manage_mobile from "../components/Manage_mobile/Manage_mobile";
import Manage_internet from "../components/Manage_internet/Manage_internet";
import Manage_request_mobile from "../components/Manage_request/Manage_request_mobile";
import Manage_request_internet from "../components/Manage_request/Manage_request_internet";
import History_mobileOper from "../components/Manage_mobile/History_mobileOper";
import History_mobileAdmin from "../components/Manage_mobile/History_mobileAdmin";
import Add_promotion_mobile from "../components/Manage_mobile/Add_promotion_mobile";
import Edit_promotion_mobile from "../components/Manage_mobile/Edit_promotion_mobile";
import Alert_promotion_mobile from "../components/Manage_mobile/Alert_promotion_mobile";
import History_internet from "../components/Manage_internet/History_internet";
import Add_promotion_internet from "../components/Manage_internet/Add_promotion_internet";
import Edit_promotion_internet from "../components/Manage_internet/Edit_promotion_internet";
import Add_file_promotion_internet from "../components/Manage_internet/Add_file_promotion_internet";
import Confirm_promotion_internet from "../components/Manage_internet/Confirm_promotion_internet";
import Alert_promotion_internet from "../components/Manage_internet/Alert_promotion_internet";
import Manage_data from "../components/Manage_data/Manage_data";
import Confirm_data from "../components/Manage_data/Confirm_data";
import Alert_data from "../components/Manage_data/Alert_data";
import Edit_admin from "../components/Manage_admin/Edit_admin";
import Report_promotion_mobile_type from "../components/Report/Report_promotion_mobile_type";
import Report_promotion_ranking from "../components/Report/Report_promotion_ranking";
import Services_rate from "../components/Report/Services_rate";
import Services_change from "../components/Report/Services_change";
import Program_technologies from "../components/Report/Program_technologies";
import Pro_seconds_G5 from "../components/Report/Pro_seconds_G5";
import Fast_internet_home_G9 from "../components/Report/Fast_internet_home_G9";
import Fast_internet_home_G11 from "../components/Report/Fast_internet_home_G11";
import Fast_internet_home_G12 from "../components/Report/Fast_internet_home_G12";
import Promotion_table_avg from "../components/Report/Promotion_table_avg";
import Promotion_percent from "../components/Report/Promotion_percent";
import Services_trends from "../components/Report/Services_trends";
import Services_internet from "../components/Report/Services_internet";
import report_exporting from "../components/Report/report_exporting";
import Upload_save from "../components/Monthly_promotion/Upload_save";
import Add_uploadsave from "../components/Monthly_promotion/Add_uploadsave";
import Upload_saveMonthly from "../components/Monthly_promotion/Upload_saveMonthly";
import Confirm_promotion_Monthlymobile from "../components/Monthly_promotion/Confirm_promotion_Monthlymobile";
import Alert_promotion_Monthlymobile from "../components/Monthly_promotion/Alert_promotion_Monthlymobile";
import Alert_promotion_broadband from "../components/Monthly_promotion/Alert_promotion_broadband";
import Confirm_promotion_broadband from "../components/Monthly_promotion/Confirm_promotion_broadband";
import Typegroup from "../components/Manage_typeGroup/Typegroup";
import Add_typegroup from "../components/Manage_typeGroup/Add_typegroup";
import Edit_typegroup from "../components/Manage_typeGroup/Edit_typegroup";
import ListOperator from "../components/Operator/ListOperator";
import Add_ListOperator from "../components/Operator/Add_ListOperator";
import Edit_ListOperator from "../components/Operator/Edit_ListOperator";
import Manage_average from "../components/ManageServiceRates/Manage_average";
import Manage_averageAdd from "../components/ManageServiceRates/Manage_averageAdd";
import Manage_averageEdit from "../components/ManageServiceRates/Manage_averageEdit";
import Manage_service from "../components/Manage_service/Manage_service";
import Edit_service from "../components/Manage_service/Edit_service";
import Confirm_uploadsave from "../components/Report/Confirm_uploadsave";
import Alert_uploadsave from "../components/Report/Alert_uploadsave";
import Reportview_promotion from "../components/Report/Reportview_promotion";
import Manage_terms_and_condition from "../components/Manage_consent/Manage_terms_and_condition";
import Manage_security_policy from "../components/Manage_consent/Manage_security_policy";
import Manage_privacy_data_policy from "../components/Manage_consent/Manage_privacy_data_policy";
import Manage_cookie_privacy from "../components/Manage_consent/Manage_cookie_privacy";
import Manage_question from "../components/Manage_question/Manage_question";
import Manage_questionAdd from "../components/Manage_question/Manage_questionAdd";
import Manage_questionEdit from "../components/Manage_question/Manage_questionEdit";
import Manage_article from "../components/Manage_article/Manage_article";
import Manage_articleAdd from "../components/Manage_article/Manage_articleAdd";
import Manage_articleEdit from "../components/Manage_article/Manage_articleEdit";
import Forget_password from "../components/Forget_password";
import Manage_news from "../components/Manage_news/Manage_news";
import Manage_newsAdd from "../components/Manage_news/Manage_newsAdd";
import Manage_newsEdit from "../components/Manage_news/Manage_newsEdit";
import Report_blockchain from "../components/Report_blockChain/Report_blockchain";
import Report_blockchainDetail from "../components/Report_blockChain/Report_blockchainDetail";
import Popular_proMobile from "../components/Manage_mobile/Popular_proMobile";
import Popular_proInternet from "../components/Manage_internet/Popular_proInternet";
import Activate from "../components/Activate";
import Unsubscribe from "../components/Unsubscribe";
import auth from "../middleware/auth";
import log from "../middleware/log";
import Manage_mobile_service from "../components/Manage_mobile_service/Manage_mobile_service"
import Edit_mobile_service from "../components/Manage_mobile_service/Edit_mobile_service"
import User_behavior from "../components/Report/User_behavior"
import Terms_and_condition from "../components/Terms_and_condition"
import User_privacy from "../components/User_privacy"
import Security_policy from "../components/Security_policy"
import Cookie_policy from "../components/Cookie_policy"
import Contact_admin from "../components/Contact_admin"
import Uteleme from "../components/Report/Uteleme"
import Reset_password from "../components/Reset_password"
import Manage_banner from "../components/Manage_banner/Manage_banner"
import { MessageBox } from "element-ui";
import moment from 'moment'

Vue.use(Router);

const router = new Router({
    base: process.env.NODE_ENV === "production" ? "/" : "/",
    mode: "history",
    scrollBehavior(to) {
        if (to.hash) {
            return window.scrollTo({
                top: document.querySelector(to.hash).offsetTop,
                behavior: "smooth"
            });
        }
        return window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    },
    routes: [{
            path: "/Activate/:type/:activate_token",
            name: "Activate",
            component: Activate
        },
        {
            path: "/Login",
            name: "Login",
            component: Login
        },
        {
            path: "/Forget_password",
            name: "Forget_password",
            component: Forget_password
        },
        {
            path: "/Register",
            name: "Register",
            component: Register
        },
        {
            path: '/', 
            redirect: '/Login'
        },
        {
            path: "/resetpassword",
            redirect: '/Login'
        },
        {
            path: "/activate/setpassword/:activate_token",
            name: "Set_password",
            component: Reset_password
        },
        {
            path: "/resetpassword/:forgot_token",
            name: "Reset_password",
            component: Reset_password
        },
        {
            path: "/Unsubscribe/:email",
            name: "Unsubscribe",
            component: Unsubscribe
        },
        {
            path: "/Admin",
            name: "Admin",
            component: Layout,
            children: [{
                    path: "Report_blockchain",
                    name: "Report_blockchain",
                    component: Report_blockchain,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Report_blockchainDetail",
                    name: "Report_blockchainDetail",
                    component: Report_blockchainDetail,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_mobile_service",
                    name: "Manage_mobile_service",
                    component: Manage_mobile_service,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Edit_mobile_service/:id/:proportion_minute/:proportion_second",
                    name: "Edit_mobile_service",
                    component: Edit_mobile_service,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Popular_proMobile",
                    name: "Popular_proMobile",
                    component: Popular_proMobile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Popular_proInternet",
                    name: "Popular_proInternet",
                    component: Popular_proInternet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Dashboard",
                    name: "DashboardAdmin",
                    component: Dashboard,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "FileSystem",
                    name: "FileSystem",
                    component: FileSystem,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_user",
                    name: "Manage_user",
                    component: Manage_user,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Profile",
                    name: "Profile",
                    component: Profile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_admin",
                    name: "Manage_admin",
                    component: Manage_admin,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_admin/Edit_admin",
                    name: "Edit_admin",
                    component: Edit_admin,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Report_sell_internet",
                    name: "Report_sell_internet",
                    component: Report_sell_internet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Report_sell_mobile",
                    name: "Report_sell_mobile",
                    component: Report_sell_mobile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_admin/Add_admin",
                    name: "Add_admin",
                    component: Add_admin,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_operator",
                    name: "Manage_operator",
                    component: Manage_operator,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Access_log",
                    name: "Access_log",
                    component: Access_log,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_terms_and_condition",
                    name: "Manage_terms_and_condition",
                    component: Manage_terms_and_condition,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_privacy_data_policy",
                    name: "Manage_privacy_data_policy",
                    component: Manage_privacy_data_policy,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_security_policy",
                    name: "Manage_security_policy",
                    component: Manage_security_policy,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_cookie_privacy",
                    name: "Manage_cookie_privacy",
                    component: Manage_cookie_privacy,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_question",
                    name: "Manage_question",
                    component: Manage_question,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_question_add",
                    name: "Manage_question_add",
                    component: Manage_questionAdd,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_questionEdit",
                    name: "Manage_questionEdit",
                    component: Manage_questionEdit,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_article",
                    name: "Manage_article",
                    component: Manage_article,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_article_add",
                    name: "Manage_article_add",
                    component: Manage_articleAdd,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_articleEdit",
                    name: "Manage_articleEdit",
                    component: Manage_articleEdit,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_news",
                    name: "Manage_news",
                    component: Manage_news,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_news_add",
                    name: "Manage_news_add",
                    component: Manage_newsAdd,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_newsEdit",
                    name: "Manage_newsEdit",
                    component: Manage_newsEdit,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_banner",
                    name: "Manage_banner",
                    component: Manage_banner,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_operator/Add_operator",
                    name: "Add_operator",
                    component: Add_operator,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_operator/Edit_operator",
                    name: "Edit_operator",
                    component: Edit_operator,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_mobile",
                    name: "Manage_mobile",
                    component: Manage_mobile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_internet",
                    name: "Manage_internet",
                    component: Manage_internet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_request_mobile",
                    name: "Manage_request_mobile",
                    component: Manage_request_mobile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_request_internet",
                    name: "Manage_request_internet",
                    component: Manage_request_internet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "History_mobileAdmin",
                    name: "History_mobileAdmin",
                    component: History_mobileAdmin,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "History_internet",
                    name: "History_internet",
                    component: History_internet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_data",
                    name: "Manage_data",
                    component: Manage_data,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Confirm_data",
                    name: "Confirm_data",
                    component: Confirm_data,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Alert_data",
                    name: "Alert_data",
                    component: Alert_data,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Report_promotion_mobile_type",
                    name: "Report_promotion_mobile_type",
                    component: Report_promotion_mobile_type,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Report_promotion_ranking",
                    name: "Report_promotion_ranking",
                    component: Report_promotion_ranking,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Services_rate",
                    name: "Services_rate",
                    component: Services_rate,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Services_change",
                    name: "Services_change",
                    component: Services_change,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Program_technologies",
                    name: "Program_technologies",
                    component: Program_technologies,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Pro_seconds_G5",
                    name: "Pro_seconds_G5",
                    component: Pro_seconds_G5,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Fast_internet_home_G9",
                    name: "Fast_internet_home_G9",
                    component: Fast_internet_home_G9,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Promotion_table_avg",
                    name: "Promotion_table_avg",
                    component: Promotion_table_avg,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Promotion_percent",
                    name: "Promotion_percent",
                    component: Promotion_percent,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Fast_internet_home_G11",
                    name: "Fast_internet_home_G11",
                    component: Fast_internet_home_G11,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Fast_internet_home_G12",
                    name: "Fast_internet_home_G12",
                    component: Fast_internet_home_G12,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Services_trends",
                    name: "Services_trends",
                    component: Services_trends,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Services_internet",
                    name: "Services_internet",
                    component: Services_internet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "report_exporting",
                    name: "report_exporting",
                    component: report_exporting,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Upload_save",
                    name: "Upload_save",
                    component: Upload_save,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                // {
                //   path: "Add_uploadsave",
                //   name: "Add_uploadsave",
                //   component: Add_uploadsave
                // },
                {
                    path: "Typegroup",
                    name: "Typegroup",
                    component: Typegroup,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Add_typegroup",
                    name: "Add_typegroup",
                    component: Add_typegroup,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Edit_typegroup",
                    name: "Edit_typegroup",
                    component: Edit_typegroup,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "ListOperator",
                    name: "ListOperator",
                    component: ListOperator,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Add_ListOperator",
                    name: "Add_ListOperator",
                    component: Add_ListOperator,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Edit_ListOperator",
                    name: "Edit_ListOperator",
                    component: Edit_ListOperator,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_averageEdit/:namePromotion/:minute/:price_sms/:price_mms/:internet/:date_first/:date_final/:id",
                    name: "Manage_averageEdit",
                    component: Manage_averageEdit,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_averageAdd",
                    name: "Manage_averageAdd",
                    component: Manage_averageAdd,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_average",
                    name: "Manage_average",
                    component: Manage_average,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_service",
                    name: "Manage_service",
                    component: Manage_service,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Edit_service/:id/:proportion_main_promotion/:proportion_ontop_promotion",
                    name: "Edit_service",
                    component: Edit_service,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                // {
                //   path: "Confirm_uploadsave",
                //   name: "Confirm_uploadsave",
                //   component: Confirm_uploadsave
                // },
                {
                    path: "Alert_uploadsave",
                    name: "Alert_uploadsave",
                    component: Alert_uploadsave,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Reportview_promotion",
                    name: "Reportview_promotion",
                    component: Reportview_promotion,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "User_behavior",
                    name: "User_behavior",
                    component: User_behavior,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Uteleme",
                    name: "Uteleme",
                    component: Uteleme,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: 'Terms_and_condition',
                    name: 'Terms_and_condition',
                    component: Terms_and_condition
                },
                {
                    path: 'User_privacy',
                    name: 'User_privacy',
                    component: User_privacy
                },
                {
                    path: 'Security_policy',
                    name: 'Security_policy',
                    component: Security_policy
                },
                {
                    path: 'Cookie_policy',
                    name: 'Cookie_policy',
                    component: Cookie_policy
                }
            ]
        },
        {
            path: "/Operator",
            name: "Operator",
            component: LayoutOperator,
            children: [{
                    path: "",
                    name: "DashboardOperator",
                    component: Dashboard,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_mobileOperator",
                    name: "Manage_mobileOperator",
                    component: Manage_mobile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Profile",
                    name: "ProfileOperator",
                    component: Profile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Dashboard",
                    name: "Dashboard",
                    component: Dashboard,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "FileSystem",
                    name: "FileSystem",
                    component: FileSystem,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_mobile",
                    name: "Operator_Manage_mobile",
                    component: Manage_mobile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "History_mobileOper",
                    name: "History_mobileOper",
                    component: History_mobileOper,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_mobile/Add_promotion_mobile",
                    name: "Add_promotion_mobile",
                    component: Add_promotion_mobile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_mobile/Edit_promotion_mobile",
                    name: "Edit_promotion_mobile",
                    component: Edit_promotion_mobile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_mobile/Add_file_promotion",
                    name: "Add_file_promotion",
                    component: Add_file_promotion,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_mobile/Alert_promotion_mobile",
                    name: "Alert_promotion_mobile",
                    component: Alert_promotion_mobile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_internet",
                    name: "Operator_Manage_internet",
                    component: Manage_internet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "History_internet",
                    name: "History_internet_operator",
                    component: History_internet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_internet/Add_promotion_internet",
                    name: "Add_promotion_internet",
                    component: Add_promotion_internet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_internet/Edit_promotion_internet",
                    name: "Edit_promotion_internet",
                    component: Edit_promotion_internet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_internet/Add_file_promotion_internet",
                    name: "Add_file_promotion_internet",
                    component: Add_file_promotion_internet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_internet/Confirm_promotion_internet",
                    name: "Confirm_promotion_internet",
                    component: Confirm_promotion_internet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_internet/Alert_promotion_internet",
                    name: "Alert_promotion_internet",
                    component: Alert_promotion_internet,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_data",
                    name: "Manage_data",
                    component: Manage_data,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Confirm_data",
                    name: "Confirm_data",
                    component: Confirm_data,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Alert_data",
                    name: "Alert_data",
                    component: Alert_data,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Upload_save",
                    name: "Upload_save",
                    component: Upload_save,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Add_uploadsave",
                    name: "Add_uploadsave",
                    component: Add_uploadsave,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Confirm_promotion_Monthlymobile",
                    name: "Confirm_promotion_Monthlymobile",
                    component: Confirm_promotion_Monthlymobile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Upload_saveMonthly",
                    name: "Upload_saveMonthly",
                    component: Upload_saveMonthly,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Alert_promotion_Monthlymobile",
                    name: "Alert_promotion_Monthlymobile",
                    component: Alert_promotion_Monthlymobile,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Confirm_promotion_broadband",
                    name: "Confirm_promotion_broadband",
                    component: Confirm_promotion_broadband,
                    meta: {
                        middleware: [auth, log],
                    }
                },
                {
                    path: "Alert_promotion_broadband",
                    name: "Alert_promotion_broadband",
                    component: Alert_promotion_broadband,
                    meta: {
                        middleware: [auth, log],
                    }
                },
                {
                    path: "Manage_average/:id",
                    name: "Manage_average",
                    component: Manage_averageAdd,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_average",
                    name: "Manage_average",
                    component: Manage_averageAdd,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_average",
                    name: "Manage_average",
                    component: Manage_average,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Manage_service",
                    name: "Manage_service",
                    component: Manage_service,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Edit_service",
                    name: "Edit_service",
                    component: Edit_service,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Confirm_uploadsave",
                    name: "Confirm_uploadsave",
                    component: Confirm_uploadsave,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Alert_uploadsave",
                    name: "Alert_uploadsave",
                    component: Alert_uploadsave,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Reportview_promotion",
                    name: "Reportview_promotion",
                    component: Reportview_promotion,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Report_blockchain",
                    name: "Report_blockchain",
                    component: Report_blockchain,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "User_behavior",
                    name: "User_behavior_operator",
                    component: User_behavior,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: "Contact_admin",
                    name: "Contact_admin",
                    component: Contact_admin,
                    meta: {
                        middleware: [auth, log]
                    }
                },
                {
                    path: 'Terms_and_condition',
                    name: 'Terms_and_condition',
                    component: Terms_and_condition
                },
                {
                    path: 'User_privacy',
                    name: 'User_privacy',
                    component: User_privacy
                },
                {
                    path: 'Security_policy',
                    name: 'Security_policy',
                    component: Security_policy
                },
                {
                    path: 'Cookie_policy',
                    name: 'Cookie_policy',
                    component: Cookie_policy
                }
            ]
        }
    ],
    linkActiveClass: 'active'
});

router.beforeEach((to, from, next) => {
    if (to.name == 'Admin'){
        if($cookies.get("user_nbtc")){
            return router.push({
                name: "Dashboard"
            });
        }
    }else if (to.name == "Login") {
        if ($cookies.get("user_nbtc")) {
            return router.push({
                name: "Dashboard"
            });
        }
    }else if(!$cookies.get("user_nbtc")){
        // console.log(to)
    }
    if ($cookies.isKey("procheck_timeout")) {
        let timeout = moment($cookies.get("procheck_timeout").timeout)
        let current_time = moment(new Date)
        let diff_time = timeout.diff(current_time, 'seconds')
        if (diff_time < 0) {
            $cookies.get('user_nbtc') ? $cookies.remove('user_nbtc') : null
            $cookies.remove("procheck_timeout")
            MessageBox.confirm("โทเค็นหมดอายุ","แจ้งเตือน", {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: "warning"
            }).then().catch()
        } else {
            $cookies.set("procheck_timeout", { timeout: moment(new Date).add(30, 'minute') })
        }
    }
    
    if (!to.meta.middleware) {
        return next();
    }

    const middleware = to.meta.middleware;

    const context = {
        from,
        next,
        router,
        to
    };
    return middleware[0]({
        ...context
    });
});

export default router;